import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import TR from './../../Trans';
import { GlobalStyles } from "@mui/material";
import backgroundImage from "../../assets/people-group-4-square.jpg";
import Box from '@mui/material/Box';
import ThemeToggleButton from '../items/ThemeToggleButton';
import { Capacitor } from '@capacitor/core';
import TextField from '@mui/material/TextField';
import { useLocalStorage } from '../../services/useLocalStorage';
import Button from '@mui/material/Button';
import { ReactComponent as MuvikaLogo } from './../../assets/logo-horiz.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import CssBaseline from '@mui/material/CssBaseline';
import muvikaAttrs from './../../attrs';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import Waiting from './../items/Waiting';
import Error from './../items/Error';
import Message from './../items/Message';
import Container from '@mui/material/Container';
import sessionStore from './../../stores/session';
import accountStore from './../../stores/account';
import environmentStore from './../../stores/environment';
import messageStore from './../../stores/message';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

function ForgotPassword() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const [, updateState] = useState();

  const sessionToken = sessionStore((state) => state.sessionToken);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const updateSession = sessionStore((state) => state.updateSession);
  const isSessionOpen = sessionStore((state) => state.isSessionOpen);
  const isSessionOpening = sessionStore((state) => state.isSessionOpening);
  const openSession = sessionStore((state) => state.openSession);
  const createAccountPin = accountStore((state) => state.createAccountPin);
  const isAccountPinSet = accountStore((state) => state.isAccountPinSet);
  const verifyPin = accountStore((state) => state.verifyPin);
  const verificationCode = accountStore((state) => state.verificationCode);
  const clearAccountStore = accountStore((state) => state.clearAll);
  const setError = messageStore((state) => state.setError);
  const changeForgottenPassword = accountStore((state) => state.changeForgottenPassword);
  const isForgottenPasswordChanged = accountStore((state) => state.isForgottenPasswordChanged);
  const clearVerifications = accountStore((state) => state.clearVerifications);
  const isWaiting = accountStore((state) => state.isWaiting);

  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem(muvikaAttrs.service + "-session-language");
    const initialValue = JSON.parse(saved);
    return initialValue || "";
  });

  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');

  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);


  useEffect(() => {
    if (language.length > 0) {
      handleLanguageChange(language);
    }
    setEmail("");
    setPin("");
    setNewPassword1("");
    setNewPassword2("");
    clearAccountStore();
    clearVerifications();
    document.title = TR.ww_page_title;
  }, []);

  const handleLanguageChange = (language) => {
    let lowLang = language.toLowerCase();
    updateSession(sessionToken, lowLang);
    updateState({});
  };

  useEffect(() => {
    if (!isSessionOpen && !isSessionOpening) {
      openSession(language.length > 0 ? language.toLowerCase() : "english");
    }
  });

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleChangeForgottenPassword = () => {
    if (verificationCode) {
      if (newPassword1.length >= 8) {
        if (newPassword1 === newPassword2) {
          changeForgottenPassword(sessionToken, email, newPassword1, verificationCode);
        } else {
          setError(sessionToken, 0, TR.ww_passwords_must_match);
        }
      } else {
        setError(sessionToken, 0, TR.cm_password_requirements);
      }
    } else {
      setError(sessionToken, 0, TR.ss_failed_to_update_password);
    }
  };

  const handleKeyDownEmail = (event) => {
    if (event.key === 'Enter') {
      handleAccountPinCreation();
    }
  };

  const handleKeyDownChangePassword = (event) => {
    if (event.key === 'Enter') {
      handleChangeForgottenPassword();
    }
  };

  const handleKeyDownVerifyPin = (event) => {
    if (event.key === 'Enter') {
      verifyPin(sessionToken, pin, email, "change_password");
    }
  };

  const handleAccountPinCreation = () => {
    createAccountPin(sessionToken, email, "change_password");
  };

  const renderAskForEmail = () => {
    return <Box sx={{ width: "100%" }} onKeyDown={handleKeyDownEmail}>
      <Box sx={{ margin: 2 }}>
        <p>
          {TR.ww_enter_email_address_to_change_password_1}
        </p>
        <p>
          {TR.ww_enter_email_address_to_change_password_2}
        </p>
      </Box>
      <Box sx={{ margin: 2 }}>

        <InputLabel>{TR.cm_username}</InputLabel>
        <TextField
          size="small"
          margin="normal"
          required
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value.toLowerCase())}
        />
      </Box>
      <Stack direction="row" spacing={6} justifyContent="center">
        <Button href="#/login" variant="text" color="secondary">{TR.cm_cancel}</Button>
        <Button
          onClick={handleAccountPinCreation}
          variant="text"
          color="success"
        >
          {TR.cm_next}
        </Button>
      </Stack>
    </Box>;
  };

  const renderWaitingOrEmail = () => {
    if (isWaiting) {
      return <Waiting />;
    } else {
      return renderAskForEmail();
    }
  };

  const renderAskForPassword = () => {
    return <Box sx={{ width: "100%" }} onKeyDown={handleKeyDownChangePassword}>

      <Box sx={{ margin: 2 }}>

        <InputLabel>{TR.cm_new_password}</InputLabel>
        <OutlinedInput
          id="forgot-password1"
          size="small"
          margin="normal"
          required
          fullWidth
          value={newPassword1}
          onChange={(e) => setNewPassword1(e.target.value)}
          type={showPassword1 ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword1(!showPassword1)}
                onMouseDown={() => setShowPassword1(!showPassword1)}
                edge="end"
              >
                {showPassword1 ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <InputLabel>{TR.cm_new_password_again}</InputLabel>
        <OutlinedInput
          id="forgot-password2"
          size="small"
          margin="normal"
          required
          fullWidth
          value={newPassword2}
          onChange={(e) => setNewPassword2(e.target.value)}
          type={showPassword2 ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword2(!showPassword2)}
                onMouseDown={() => setShowPassword2(!showPassword2)}
                edge="end"
              >
                {showPassword2 ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </Box>
      <Stack direction="row" spacing={6} justifyContent="center">
        <Button href="#/login" variant="text" color="secondary">{TR.cm_cancel}</Button>
        <Button
          onClick={handleChangeForgottenPassword}
          variant="text"
          color="success"
        >
          {TR.cm_change_password}
        </Button>
      </Stack>
    </Box>;
  };

  const renderAskForPin = () => {
    return <Box sx={{ width: "100%" }} onKeyDown={handleKeyDownVerifyPin}>
      <Box sx={{ margin: 2 }}>
        <p>
          {TR.cm_account_creation_pin_sent}
        </p>
        <InputLabel>{TR.cm_pin}</InputLabel>
        <TextField
          autoFocus
          size="small"
          margin="normal"
          type="text"
          required
          fullWidth
          value={pin}
          onChange={(e) => setPin(e.target.value)}
        />
      </Box>
      <Stack direction="row" spacing={6} justifyContent="center">
        <Button variant="text" color="secondary" onClick={() => {
          clearVerifications();
          setEmail("");
        }}>{TR.cm_cancel}</Button>
        <Button
          onClick={() => verifyPin(sessionToken, pin, email, "change_password")}
          variant="text"
          color="success"
        >
          {TR.cm_next}
        </Button>
      </Stack>
    </Box>;
  };

  const renderSuccess = () => {
    return <Box sx={{ width: "100%" }}>
      <Box sx={{ margin: 2 }}>
        <p>
          {TR.ww_password_changed}
        </p>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button
            href="#/"
            variant="text"
            color="success"
          >
            {TR.cm_back}
          </Button>
        </Stack>
      </Box>
    </Box>;
  };

  const renderForgottenPasswordForm = () => {
    if (!isForgottenPasswordChanged) {
      if (verificationCode) {
        return renderAskForPassword();
      } else {
        if (!isAccountPinSet) {
          return renderWaitingOrEmail();
        } else {
          return renderAskForPin();
        }
      }
    } else {
      //clearAccountStore();
      //clearVerifications();
      return renderSuccess();
    }
  };

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaLogo className="muvika-logo-svg" />;
    } else {
      return <MuvikaLogoInv className="muvika-logo-svg" />;
    }
  };

  const renderIfSessionOpen = () => {
    if (isSessionOpen && !isLoggedIn) {
      return <ThemeProvider theme={darkTheme}>
        <Container className="muvika-entry-container" component="main" maxWidth="xs">
          <CssBaseline />
          <Error />
          <Message />
          <Box
            className="muvika-entry-box"
          >
            <p>
              <a href="#/">{renderLogo()}</a>
            </p>
            {renderForgottenPasswordForm()}
            <ThemeToggleButton />
          </Box>
        </Container>
      </ThemeProvider >;
    } else {
    }
  };

  const renderIfLoggedIn = () => {
    if (isSessionOpen && isLoggedIn) {
      return <Navigate to="/" />;
    }
  };

  const overflowStyleIos = `
  html {
    overflow-y:scroll !important;
  }
  
  body {
    overflow-y:scroll !important;
  }
  
  main {
    overflow-y:scroll !important;
  }
`;

  const overflowStyle = `
  html {
    overflow-y:auto !important;
  }
  
  body {
    overflow-y:auto !important;
  }
  
  main {
    overflow-y:auto !important;
  }
`;

  const renderOverflowStyle = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return <style>
        {overflowStyleIos}
      </style>;
    } else {
      return <style>
        {overflowStyle}
      </style>;
    }
  };

  return (
    <div>
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            minHeight: "100vh",
            minWidth: "100vw",
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundRepeat: "no-repeat !important",
            backgroundSize: "cover !important",
            backgroundPosition: "center !important",
          },
        }}
      />
      {renderOverflowStyle()}
      {renderIfLoggedIn()}
      {renderIfSessionOpen()}
    </div>
  );
}

export default ForgotPassword;